/**
 * Joins array values with a separator, skipping falsy values.
 * @param {Array} items - Array of strings or values
 * @param {string} separator - Separator string (default: " • ")
 * @returns {string} - Joined string
 */
export function joinWithSeparator(items = [], separator = " • ") {
  return items.filter(Boolean).join(separator)
}

/**
 * Generate a social-media safe hashtag from a string.
 * Replaces spaces/special characters with underscores.
 * @param {string} text - Input text
 * @param {boolean} lowercase - Make hashtag lowercase (default: false)
 * @returns {string} - Safe hashtag (e.g. "#STK250010" or "#toyota_corolla")
 */
export const generateHashtag = (text, lowercase = false) => {
  if (!text || typeof text !== "string") return ""

  // Remove invalid characters: keep letters, numbers, underscores only
  let formatted = text
    .trim()
    .replace(/[^a-zA-Z0-9_]/g, "") // remove all invalid characters
    .replace(/\s+/g, "") // remove spaces

  if (lowercase) formatted = formatted.toLowerCase()

  return `#${formatted}`
}


